/* Product page quantity stepper (Husnain, 2026-10). Quantity discounts are handled by the Pumper Bundles widget. */
(function () {
  var form = document.getElementById('add-to-cart-form');
  if (!form) return;

  // Pumper widget: our placeholder stays until the widget has real titles and prices (it first shows empty titles and
  // £0.00), then .gt-qb-ready swaps them. If the widget never shows (offer paused, app removed), drop the placeholder.
  // If it shows but never fills in (Pumper's request failed on a slow connection), .gt-qb-failed hides it and brings back
  // our quantity box; it still swaps in if Pumper finishes later.
  var slot = form.querySelector('[data-gt-qb-slot]');
  if (slot) {
    var seen = false;
    var filled = false;
    var quiet = null;
    var observer = null;
    var markReady = function () {
      form.classList.remove('gt-qb-failed');
      form.classList.add('gt-qb-ready');
      if (observer) observer.disconnect();
    };
    var giveUp = function () {
      if (form.classList.contains('gt-qb-ready')) return;
      var widget = form.querySelector('#svelte-bundle-widget');
      var text = widget ? (widget.innerText || '').trim() : '';
      // Drew fine but with markup the check below doesn't know: show it. Blank or £0.00: fall back.
      if (text.length > 20 && !/(^|[^\d.,])0[.,]00(?!\d)/.test(text)) markReady();
      else form.classList.add('gt-qb-failed');
    };
    var isFilled = function (widget) {
      var titles = widget.querySelectorAll('.pmpr-tier-title');
      var texts = widget.querySelectorAll('.pmpr-money-text');
      var prices = 0;
      if (!titles.length) return false;
      for (var i = 0; i < titles.length; i++) {
        if (!titles[i].textContent.trim()) return false;
      }
      // Pumper uses this class for every text bit; only the ones that look like a price must be non-zero.
      for (var j = 0; j < texts.length; j++) {
        var text = texts[j].textContent;
        if (!/\d[.,]\d{2}/.test(text)) continue;
        if (!/[1-9]/.test(text)) return false;
        prices++;
      }
      return prices > 0;
    };
    var check = function () {
      var widget = form.querySelector('#svelte-bundle-widget');
      if (!widget) return;
      if (!seen) {
        seen = true;
        setTimeout(giveUp, 10000);
      }
      if (!isFilled(widget)) return;
      // Its header line lands just after the prices: swap once it has been quiet for a moment.
      if (!filled) {
        filled = true;
        setTimeout(markReady, 1200);
      }
      clearTimeout(quiet);
      quiet = setTimeout(markReady, 300);
    };
    observer = new MutationObserver(check);
    observer.observe(form, { childList: true, subtree: true, characterData: true });
    check();
    window.addEventListener('load', function () {
      setTimeout(function () {
        if (!form.querySelector('#svelte-bundle-widget') && slot.parentNode) {
          slot.parentNode.removeChild(slot);
          if (observer) observer.disconnect();
        }
      }, 6000);
    });
  }

  var qty = form.querySelector('[data-gt-qty]');
  if (!qty) return;

  function currentQty() {
    return Math.max(1, parseInt(qty.value, 10) || 1);
  }

  form.addEventListener('click', function (event) {
    var step = event.target.closest('[data-gt-qty-step]');
    if (!step) return;
    event.preventDefault();
    qty.value = Math.max(1, currentQty() + parseInt(step.getAttribute('data-gt-qty-step'), 10));
    qty.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
